import React from "react";
import styled from "styled-components";

import largeIconSet from "../../../assets/images/largeIconSet.png";

const ReferralFormsLayoutStyle = styled.main`
  display: flex;
`;
export const ReferralFormsLayout = (props) => {
  return (
    <ReferralFormsLayoutStyle className="h-full relative">
      <div
        className="w-1/3 hidden md:flex flex-col sticky"
        style={{ background: "#0E1D45" }}
      >
        <img src={largeIconSet} 
          alt="" 
          className="h-screen sticky top-0" 
          // style={{ maxHeight: "100vh" }} 
        />
      </div>
      <div className="w-full md:w-2/3">{props.children}</div>
    </ReferralFormsLayoutStyle>
  );
};
